enum AICommands {
  activate = '+ai',
  deactivate = '-ai',
  empty = '',
}

enum CartItemAdditionTypes {
  human = 'human',
  AI = 'ai',
}

enum EventTypes {
  start = 'start',
  audio = 'audio',
  text = 'text',
  info = 'info',
  endSession = 'end_session',
  order = 'order',
  orderStatus = 'order_status',
  loyalty = 'loyalty',
  loyaltyStatus = 'loyalty_status',
  hypothesis = 'hypothesis',
  startSession = 'start_session',
  carExit = 'car_exit',
  carEnter = 'car_enter',
  check = 'check',
  coupon = 'coupon',
  TTSRequest = 'tts_request',
  TTSOff = 'tts_off',
  TTSOn = 'tts_on',
  error = 'error',
  staffIntervention = 'staff_intervention',
  agentFirstInterception = 'agent_first_interception',
  agentInterception = 'agent_interception',
  connect = 'connect',
  disconnect = 'disconnect',
  aiEscalation = 'ai_escalation',
  hitlSessionStart = 'hitl_session_start',
  hitlSessionEnd = 'hitl_session_end',
  aiStatus = 'ai_status',
  agentActivity = 'agent_activity',
  agentFirstActivity = 'agent_first_activity',
  hitlEventConnection = 'hitl_event_connection',
  cancelOrder = 'cancel_order',
  languageSwitch = 'language_switch',
  asrIncorrect = 'asr_incorrect',
}

enum AgentTypes {
  HITL = 'HITL',
  RULAI = 'RULAI',
  prestoAI = 'PRESTOAI',
  llm = 'LLM',
  orderBoard = 'ORDERBOARD',
  restaurantStaff = 'RESTAURANTSTAFF',
  taskManager = 'TASK_MANAGER',
  dialogManager = 'DIALOGMANAGER',
  menuModule = 'MENU_MODULE',
}

enum StatusResponseTypes {
  success = 'Success',
  error = 'Error',
}

enum CheckResponseTypes {
  ok = 'ok',
  error = 'error',
  unknown = 'unknown',
}

enum CouponResponseTypes {
  ok = 'ok',
  completed = 'COMPLETED',
  unknown = 'UNKNOWN',
  error = 'error',
}

enum EventSources {
  prestoVoice = 'PRESTOVOICE',
}

const TTS_PRIORITY_BY_INTENT: Record<string, number> = {
  '#greet': 500,
  '#acknowledge': 700,
  '#ask-repeat': 500,
  '#ask-moment': 700,
  '#request-staff': 100,
  '#continue': 500,
  '#confirm': 500,
  '#readback': 200,
  '#window': 200,
};

const TTS_PRIORITY_DEFAULT = 500;

export {
  AICommands,
  AgentTypes,
  CartItemAdditionTypes,
  CheckResponseTypes,
  CouponResponseTypes,
  EventSources,
  EventTypes,
  StatusResponseTypes,
  TTS_PRIORITY_BY_INTENT,
  TTS_PRIORITY_DEFAULT,
};
